export const baseUrl = "https://test.baas.batterypool.com";
const baseTestUrl = "https://test.baas.batterypool.com";

export const endpoints = {
  baseUrl,
  s3SignedUrl: `${baseUrl}/iot/iot/createS3SignedUrl`,
  createPreOnboardingDriver: `${baseUrl}/driver/api/createPreOnboardingDriver`,
  createOnboardingDriver: `${baseUrl}/driver/api/createOnboardingDriver`,
  getPreOnboardingDriver: `${baseUrl}/driver/api/getPreOnboardingDriver`,
  getOnboardingDriver: `${baseUrl}/driver/api/getOnboardingDriver`,
  updatePreOnboardingDriverStatus: `${baseUrl}/driver/api/updatePreOnboardingDriverStatus`,
  getListOfOnboardingPRN: `${baseUrl}/driver/api/getListOfOnboardingPRN`,
  loanEmiCalculation: `${baseUrl}/general/api/loanEmiCalculation`,
  // loanEmiCalculation: `${baseUrl}/payments/payment/razorpayWebhookTest`,
  getAdminEmiConfig: `${baseUrl}/general/api/getAdminEmiConfig`,
  getCities: `${baseUrl}/general/api/getCities`,
  createDriverOfOnboarding: `${baseUrl}/driver/api/createDriverOfOnboarding`,
  createDriver: `${baseUrl}/driver/api/drivers`,

  createDriverLead: `${baseUrl}/general/api/createDriverLead`,
  updateDriverLead: `${baseUrl}/general/api/updateDriverLead`,
  getDriverLeads: `${baseUrl}/general/api/getDriverLeads`,
  getDriverLeadIds: `${baseUrl}/general/api/getDriverLeadIds`,
  getDriverLeadById: `${baseUrl}/general/api/getDriverLeadById`,
  deleteDriverLead: `${baseUrl}/general/api/deleteDriverLead`,
  addDriverLeadFeedback: `${baseUrl}/general/api/addDriverLeadFeedback`,
  getDriverLeadFeedback: `${baseUrl}/general/api/getDriverLeadFeedback`,
  resolveDriverLeadFeedback: `${baseUrl}/general/api/resolveDriverLeadFeedback`,
  loanEmiCalculationForAllFinanciers: `${baseUrl}/general/api/loanEmiCalculationForAllFinanciers`,
  getAdminEmiConfigAllFinanciers: `${baseUrl}/general/api/getAdminEmiConfigAllFinanciers`,
  getPreOnboardingDriverByPrn: `${baseUrl}/general/api/getPreOnboardingDriverByPrn`,
  updatePreOnboardingDriver: `${baseUrl}/general/api/updatePreOnboardingDriver`,
  checkDriverFieldUniqueness: `${baseUrl}/general/api/checkDriverFieldUniqueness`,

  driver: {
    ids: `${baseUrl}/driver/api/drivers/getListOfDriverIds`,
    details: (driverId, partnerId) =>
      `${baseUrl}/driver/api/getDriverDetailsProxy/${driverId}?partnerId=${partnerId}`,
  },
  partner: {
    ids: `${baseUrl}/general/api/partners/getListOfPartnerIdsWithDetails`,
    details: (partnerId) => `${baseUrl}/general/api/partners/${partnerId}`,
    billStatus: (partnerId) =>
      `${baseUrl}/general/api/partners/partnerBillStatusProxy/${partnerId}`,
  },
  device: {
    ids: `${baseUrl}/general/api/general/getDeviceIds`,
  },
  battery: {
    ids: `${baseUrl}/battery/api/batteries/getListOfBatteries`,
    initiateBatteryMovement: `${baseTestUrl}/battery/api/initiateBatteryMovement`,
    initiateBatteryMovementV2: `${baseTestUrl}/battery/api/v2/initiateBatteryMovement`,
    updateBatteryMovementStatus: `${baseTestUrl}/battery/api/updateBatteryMovementStatus`,
    updateBatteryMovement: `${baseTestUrl}/battery/api/updateBatteryMovement`,
    getBatteryMovements: `${baseTestUrl}/battery/api/getBatteryMovements`,
  },
  general: {
    getStateNames: `${baseTestUrl}/general/api/getStateNames`,
  },
  manualSwap: {
    addManualSwap: `${baseUrl}/swap/swap/v2/addManualSwap`,
    otaPost: `${baseTestUrl}/swap/swap/createTransactionTestLocal`,
    getSwapLogsBaas: `${baseTestUrl}/general/api/general/getSwapLogsBaas`,
  },
  cashCollection: {
    post: `${baseUrl}/payments/payment/createCashCollectionEntry`,
  },
  registerCashCollection: {
    post: `${baseUrl}/payments/payment/registerCashCollection`,
  },
  walletTopUp: {
    post: `${baseUrl}/payments/payment/walletTopUp`,
  },
  openDoorCommand: {
    post: `${baseUrl}/iot/iot/openDoorCommand`,
  },
};
